export default __webpack_public_path__ + "static/media/doctor.3e4ec18a.jpg";